import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { PopulationType_General, PopulationType_Specific, PopulationTypeLabelMap } from '@app/dp-shared';
import { AwaitModules, Button, TS_PropRenderer } from '@nu-art/thunderstorm-frontend/index';
import { Component_SwitchView } from '@nu-art/permissions-frontend/ui/Component_SwitchView';
import * as React from 'react';
import { _keys } from '@nu-art/ts-common';
import { DropDown_Values, DropDown_VariableV3, ModuleFE_Value, ModuleFE_Variable } from '@app/hcs-frontend';
import { ICONS } from '@app/styles';
import './Component_PopulationEditor.scss';
import { TS_EditableItemComponent } from '@nu-art/thunderstorm-frontend/editable-item';
import { DropDown_PopulationType } from '../../../_enum.js';
import { resolveValueDisplay } from '@app/hcs-shared';
const ViewMode_View = 'view';
const ViewMode_Edit = 'edit';
export class Component_PopulationEditor extends TS_EditableItemComponent {
    // ######################## Lifecycle ########################
    deriveStateFromProps(nextProps, state) {
        state = super.deriveStateFromProps(nextProps, state);
        state.editMode = nextProps.editMode;
        return state;
    }
    // ######################## Logic ########################
    getViewMode = () => this.state.editMode ? ViewMode_Edit : ViewMode_View;
    addSpecification = async () => {
        const population = this.state.editable;
        population.item.specifications[''] = '';
        await population.save();
    };
    // ######################## Render ########################
    render() {
        return _jsxs(_Fragment, { children: [this.renderPopulationType(), this.renderPopulationSpecifications()] });
    }
    renderPopulationType = () => {
        const population = this.state.editable;
        return _jsx(TS_PropRenderer.Flat, { label: 'Population', children: _jsx(Component_SwitchView, { mode: this.getViewMode(), modes: [
                    {
                        key: ViewMode_View,
                        renderer: () => _jsx("div", { className: 'population-item-editor__data span-row', children: PopulationTypeLabelMap[population.item.type] })
                    },
                    {
                        key: ViewMode_Edit,
                        renderer: () => _jsxs(_Fragment, { children: [_jsx(DropDown_PopulationType.editable, { editable: population, prop: 'type', onSelected: type => {
                                        if (type === population.item.type)
                                            return;
                                        if (type === PopulationType_General) {
                                            //@ts-ignore
                                            delete population.item.specifications;
                                            population.updateObj({ type: type });
                                        }
                                        if (type === PopulationType_Specific) {
                                            population.updateObj({ type: type, specifications: {} });
                                        }
                                    } }), _jsx("div", {})] })
                    }
                ] }) });
    };
    renderPopulationSpecifications = () => {
        const population = this.state.editable;
        if (population.item.type !== PopulationType_Specific)
            return;
        return _jsx(TS_PropRenderer.Flat, { label: 'Specifications', children: _jsx(AwaitModules, { modules: [ModuleFE_Variable, ModuleFE_Value], children: _jsx(Component_SwitchView, { mode: this.getViewMode(), modes: [
                        {
                            key: ViewMode_View,
                            renderer: () => this.renderSpecificationsView()
                        },
                        {
                            key: ViewMode_Edit,
                            renderer: () => this.renderSpecificationsEdit(),
                        }
                    ] }) }) });
    };
    renderSpecificationsView = () => {
        const population = this.state.editable;
        const variableIds = _keys(population.item.specifications ?? {});
        return variableIds.map((variableId, index) => {
            const variable = ModuleFE_Variable.cache.unique(variableId);
            const value = ModuleFE_Value.cache.unique(population.item.specifications?.[variableId]);
            return _jsxs(React.Fragment, { children: [_jsx("div", { className: 'population-editor__variable', children: variable?.name }), _jsx("div", { className: 'population-editor__value', children: value ? resolveValueDisplay(value) : '' })] }, variableId);
        });
    };
    renderSpecificationsEdit = () => {
        const population = this.state.editable;
        const variableIds = _keys(population.item.specifications ?? {});
        return _jsxs(_Fragment, { children: [variableIds.map((variableId, index) => {
                    const variable = ModuleFE_Variable.cache.unique(variableId);
                    return _jsxs(React.Fragment, { children: [_jsx(DropDown_VariableV3.selectable, { className: 'population-editor__variable-dropdown', selected: variableId, limitItems: 50, queryFilter: variable => !variableIds.includes(variable._id), onSelected: async (variable) => {
                                    delete population.item.specifications[variableId];
                                    population.item.specifications[variable._id] = '';
                                    await population.save();
                                } }), !!variable &&
                                _jsx(DropDown_Values, { className: 'population-editor__value-dropdown', variable: variable, selected: population.item.specifications[variableId] || undefined, onSelected: async (value) => {
                                        population.item.specifications[variableId] = value._id;
                                        await population.save();
                                    } })] }, variableId);
                }), _jsx(Button, { onClick: this.addSpecification, className: 'population-editor__add-specification', children: _jsx(ICONS.advisor_v5_plus.component, {}) })] });
    };
}
//# sourceMappingURL=Component_PopulationEditor.js.map